import workspaceQuery from '../../../graphql/queries/sales/SalesNoteTypeWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/sales/SalesNoteTypeListQuery.graphql';
import instanceQuery from '../../../graphql/queries/sales/SalesNoteTypeQuery.graphql';
import defaultQuery from '../../../graphql/queries/sales/SalesNoteTypeDefault.graphql';
import mutationQuery from '../../../graphql/mutations/sales/SalesNoteTypeMutation.graphql';
import fragment from '../../../graphql/fragments/sales/SalesNoteTypeFragment.graphql';
import { Direction } from '../../schema/p4types';
import { EntityType } from '../../../@types/entityTypes';

const SalesNoteType: EntityType = {
  type: 'SalesNoteType',
  title: 'Sales Note Types',
  formTitle: 'Sales Note Type',
  formUrl: '/Sales/NoteType/Details/',
  workspaceUrl: '/Sales/NoteType/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'title',
    customVariables: () => {
      return {
        orderBy: 'title',
        orderDirection: Direction.Asc,
      };
    },
  },
  fragment,
  screenReference: 'SALES_NOTE_TYPES',
};

export default SalesNoteType;
